import { useTranslation } from '@kc-console/core';

import type { DatePickerLocale } from '../types';

/**
 * i18n 언어 설정에 기반하여 DatePicker locale을 반환합니다.
 */
export const useDatePickerLocale = (propLocale?: DatePickerLocale): DatePickerLocale => {
  const { i18n } = useTranslation();
  if (propLocale) return propLocale;
  return i18n.language as DatePickerLocale;
};
